"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AggregatedPool () {
        return _AggregatedPool.AggregatedPool;
    },
    get WorkerPool () {
        return _WorkerPool.WorkerPool;
    },
    get registerWorker () {
        return _registerWorker.registerWorker;
    }
});
const _registerWorker = require("./registerWorker.js");
const _WorkerPool = require("./WorkerPool.js");
const _AggregatedPool = require("./AggregatedPool.js");
